import classNames from "classnames"
import s from '../../index.module.css';
import common from './common.module.css';
import Button from "@UI/New/Button";
import { useDispatch } from "react-redux";
import { useAddAlert } from "@/hooks/useAddAlert";
import { closeAllModal } from "@store/modalsSlise";
import { useApiSearch } from "@/hooks/useApiSearch";
import { beta, betaDirectionAPI, directionAPI } from "@/api";
import { createContext, useEffect, useState } from "react";
import useLoad from "@/hooks/useLoad";
import { Name } from "./components/Name";
import { Direction } from "./components/Direction";
import { Course } from "./components/Course";
import { getInitialState } from "./getInitialState";
import { Totic } from "./components/Totic";

export const ModalCopyMaterial = createContext(null);

const CopyMaterial = ({data}) => {
    const dispatch = useDispatch() 
    const [state, setState] = useState(getInitialState({data}));

    const setFieldInState = ({field, value}) => {
        setState((prevState) => (
            {
                ...prevState,
                [field]: value
            }
        ))
    }

    const {
        data: directions = [],
        loading: loadingDirections,
    } = useApiSearch({
        apiMethod: directionAPI.overview,
        responseKey: 'data',
        searchKey: 'search',
        minQueryLength: 0
    });
    
    const { state: courses, getState: getCourses, setState: setCourses, loading: loadingCourses } = useLoad({
        api: beta.getCourseBlocksCancel,
        params: { course_id: state?.direction },
        key: 'data',
        last: false,
        initState: {}
    })
    useEffect(()=>{
        if(!state?.direction) return;
        getCourses()
    }, [state?.direction])

    useEffect(()=>{
        if(courses?.flag_one_block == 1 && courses?.data?.length === 1){
            setFieldInState({field: 'course', value: Number(courses?.data[0].id)})
        }
    }, [courses])
    
    const { state: materials, getState: getMaterials, setState: setMaterials, loading: loadingMaterials } = useLoad({
        api: beta.getBlockThemes,
        params: { 
            blockId: state.course
        },
        initState: [],
        last: false,
        key: 'data',
    })
    
    useEffect(() => { if (state.course && data?.material_type === 'lesson') getMaterials() }, [state.course])
    
    const addAlert = useAddAlert();
    const copy = () => {
        if(!state.name?.trim()){
            addAlert({type: 'error', title: 'Ошибка валидации', text: 'Не заполнено название'})
            return;
        }
        if(!state?.direction){
            addAlert({type: 'error', title: 'Ошибка валидации', text: 'Не выбран курс'})
            return;
        }
        if(!state.course){
            addAlert({type: 'error', title: 'Ошибка валидации', text: 'Не выбран блок'})
            return;
        }
        if(!data?.material_id){
            addAlert({type: 'error', title: 'Ошибка валидации', text: 'Нет id материала'})
            return;
        }
        if(data?.material_type === 'lesson' && !state?.topic_id){
            addAlert({type: 'error', title: 'Ошибка валидации', text: 'Не выбрана тема'})
            return;
        }
        betaDirectionAPI.copy({
            material_id: data?.material_id,
            material_type: data?.material_type,
            direction_id: state?.direction,
            direction_course_id: state?.course,
            name: state.name,
            ...(data?.material_type === 'lesson' ? { theme_id: state?.topic_id } : {})
        })
        .then((res)=>{
            console.log(res)
            if(res?.data?.status === 'success'){
                const text = data?.material_type === 'probe' ? 'Пробник скопирован' : data?.material_type === 'control' ? 'Контрольная скопирована' : data?.material_type === 'lesson' ? 'Урок скопирован' : 'Тема скопирована'
                addAlert({ title: 'Успешно', text: text})
                if(
                    (data?.material_type !== 'lesson' && data?.course_id == res?.data?.data.course_id) ||
                    (data?.material_type === 'lesson' && data?.topic_id == state.topic_id)//можно заменить на ответ с сервера
                ) {
                    data?.onSuccess()
                }
                dispatch(closeAllModal())
            }
        })
    }

    return(
        <ModalCopyMaterial.Provider 
            value = {
                {
                    state,
                    setFieldInState,

                    courses,
                    setCourses,
                    loadingCourses,

                    directions,
                    loadingDirections,

                    materials,
                    setMaterials,
                    loadingMaterials
                }
            }
        >
            <div className={classNames(s.modalContainer, common.modalContainer)}>
                <div className={s.modalHeader}>
                <div className={s.modalTitleContainer}>
                    <span className={s.modalHeaderBigTitle}>
                        {
                            data?.material_type === 'probe' ? 'Копировать пробник' : data?.material_type === 'control' ? 'Копировать контрольную' : data?.material_type === 'lesson' ? 'Копировать урок' : 'Копировать тему'
                        }
                    </span>
                </div>
                </div>
                <div className={classNames(s.contentWrapper, common.contentWrapper)}>
                    <Name />
                    <Direction />
                    <Course />
                    {
                        data?.material_type === 'lesson' && <Totic />
                    }
                    <Button 
                            disabled={loadingDirections || loadingCourses || loadingMaterials}
                            onClick={copy}
                            className={common.button}>
                            Копировать
                    </Button>
                </div>
            </div>
        </ModalCopyMaterial.Provider>
    )
}
export default CopyMaterial;